import { render, staticRenderFns } from "./dashboardScreen.vue?vue&type=template&id=85eda9a4&scoped=true&"
import script from "./dashboardScreen.vue?vue&type=script&lang=ts&"
export * from "./dashboardScreen.vue?vue&type=script&lang=ts&"
import style0 from "./dashboardScreen.vue?vue&type=style&index=0&id=85eda9a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85eda9a4",
  null
  
)

export default component.exports